import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            为什么选择丁香花影院
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            五大核心优势，为你打造极致观影体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}